var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6FFED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22193_80742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.00098H24.167V24.001H8.16699V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22193_80742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.167 8.00098C11.7491 8.00098 8.16699 11.5831 8.16699 16.001C8.16699 20.4189 11.7491 24.001 16.167 24.001C20.5849 24.001 24.167 20.4189 24.167 16.001C24.167 11.5831 20.5849 8.00098 16.167 8.00098ZM19.6224 13.3885L15.8616 18.6028C15.7484 18.7609 15.5945 18.8399 15.4 18.8399C15.2056 18.8399 15.0517 18.7609 14.9384 18.6028L12.7116 15.517C12.6438 15.4224 12.7116 15.2903 12.8277 15.2903H13.6652C13.8474 15.2903 14.0206 15.3778 14.1277 15.5278L15.3991 17.292L18.2063 13.3992C18.3134 13.251 18.4849 13.1617 18.6688 13.1617H19.5063C19.6224 13.1617 19.6902 13.2938 19.6224 13.3885Z",
    fill: "#52C41A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedInIcon);
export default __webpack_public_path__ + "static/media/signedInIcon.6080c1405e1da751f3422326a3ea74c8.svg";
export { ForwardRef as ReactComponent };